export default {"src":"/_next/static/media/ellipse1.f31b9e85.svg","height":176,"width":176};